import { EmptyState, ErrorNote } from '@/components/ui/Feedback'
import { PageShell } from '@/components/layout/Page'
import { useDocumentTitle } from '@/lib/useDocumentTitle'
import { ChefHat } from 'lucide-react'
import { Link, useRouteError } from 'react-router-dom'

export function NotFoundPage() {
  useDocumentTitle('Not found')
  return (
    <PageShell className="max-w-2xl">
      <EmptyState
        icon={<ChefHat size={22} />}
        title="Nothing at this address"
        body="The page does not exist, or it moved."
        action={
          <Link
            to="/recipes"
            className="inline-flex h-9 items-center rounded-[var(--radius-field)] bg-accent px-3.5 text-sm font-medium text-on-accent hover:bg-accent-hover"
          >
            Go to recipes
          </Link>
        }
      />
    </PageShell>
  )
}

export function RouteErrorPage() {
  useDocumentTitle('Something went wrong')
  const error = useRouteError()
  const detail =
    error instanceof Error ? error.message : 'An unexpected error stopped this page loading.'

  return (
    <div className="flex min-h-dvh items-center justify-center px-6">
      <div className="w-full max-w-lg">
        <ErrorNote title="This page failed to load" body={detail} />
        <div className="mt-4 text-center">
          <Link to="/recipes" className="text-sm text-accent hover:underline">
            Back to recipes
          </Link>
        </div>
      </div>
    </div>
  )
}
